<template>
  <div>
    <div>
      <v-layout wrap justify-space-between>
        <v-flex xs6>
          <v-layout wrap>
            <v-flex xs12>
              <v-layout wrap id="dragSelectAreaContainer" style="width: 50%; position: fixed; overflow-y: scroll; height: calc(100vh - 48px); background-color: white">
                <v-flex xs12>
                  <div id="pdfContainer" style="width: 100%; position: relative;" :class="{ 'pdfContainerWithSelectionToolEnabled': isShowingSelectionTool && isOcrResultsLoaded, 'pdfContainerWithOcrResultsNotLoadedYet': isShowingSelectionTool && !isOcrResultsLoaded }">
                    <tokens-in-boxes
                      ref="tokensInBoxes"
                      v-if="isDragSelectEnabled && isOcrResultsLoaded && tokens.length > 0"
                      :propTokens="tokens"
                      :isUsingLines="isUsingSelectEntireExperience || isUsingSelectEntireEducationOrCertification || isUsingSelectEntireListOfEducationsAndCertifications"
                      @passSelectedTokens="passSelectedTokens"
                      :key="tokensInBoxesComponentKeyForRefresh"
                    />
                    <div>
                      <div v-for="(_, pageIndex) in Array(pagesNb).fill(0)" :key="pageIndex">
                        <pdf :src="pdfUrl" :page="pageIndex + 1"></pdf>
                      </div>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12>
                  <v-bottom-sheet v-model="isShowingSelectionTool" hide-overlay persistent no-click-animation content-class="rounded-pill">
                    <v-card class="py-3 px-2 rounded-t-xl rounded-b-0" flat style="border: 1px solid grey; border-bottom: none;">
                      <v-layout wrap v-if="!isOcrResultsLoaded">
                        <v-flex xs12 text-center>
                          <v-progress-circular :size="10" :width="1" indeterminate color="primary" class="mr-2"></v-progress-circular>
                          <span class="primary--text">{{ $t('1') }}</span>
                        </v-flex>
                      </v-layout>
                      <v-layout wrap v-else>
                        <v-flex xs12 v-if="isProcessingSelectedText" pb-2 pt-3>
                          <v-progress-linear indeterminate primary/>
                        </v-flex>
                        <v-flex xs12 v-else-if="selectedText" text-center>
                          <h3><span>{{ $t('x1') }}</span><span class="ml-1"> {{ $t('x2') }}</span></h3>
                          <small>
                            <div><v-icon class="mr-2" small color="primary">mdi-arrow-up-bold-box-outline</v-icon>{{ $t('x3') }}</div>
                          </small>
                          <div style="position: fixed; bottom: 1000px">
                            <vue-editor id="vueEditorForCopying" v-model="selectedText" disabled @blur="blurOfVueEditorForCopying" :editorToolbar="editorToolbar" :editorOptions="editorOptions"></vue-editor>
                          </div>
                        </v-flex>
                        <v-flex xs12 v-else>
                          <v-layout wrap>
                            <v-spacer/>
                            <v-flex xs6>
                              <h3 class="text-center">
                                {{ $t('x4') }}
                              </h3>
                            </v-flex>
                            <v-flex xs3 text-end style="padding-top: 1px">
                              <small @click="showVideoDialog" style="cursor:hand">
                                <v-icon small style="padding-bottom: 2px">mdi-play-circle</v-icon>
                                <span class="ml-1 textAsLink">{{ $t('video0') }}</span>
                              </small>
                            </v-flex>
                          </v-layout>
                          <v-layout wrap>
                            <v-spacer/>
                            <v-flex>
                              <small>
                                <div><v-icon class="mr-2" small color="black">mdi-select-drag</v-icon>{{ $t('x5') }}</div>
                              </small>
                            </v-flex>
                            <v-spacer/>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-bottom-sheet>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs6>
          <div style="position: fixed; height: 100vh; width: 50%; overflow-y: scroll;" class="whiteBackground" id="profile-sections-container">
            <v-layout wrap>
              <v-flex xs12>
                <profile-form
                  :dossier="dossier"
                  :dossierHasUnsavedChanges="dossierHasUnsavedChanges"
                  :isOcrResultsLoaded="isOcrResultsLoaded"
                  :isConsultant="isConsultant"
                  :isFromToken="isFromToken"
                  :isUsingSelectEntireExperience="isUsingSelectEntireExperience"
                  :isUsingSelectEntireEducationOrCertification="isUsingSelectEntireEducationOrCertification"
                  :cvPdfUrl="pdfUrl"
                  :cvPagesNb="pagesNb"
                  @updateProfileAndCreateDossier="updateProfileAndCreateDossier"
                  @passEditedFieldPath="passEditedFieldPath"
                  @passIsUsingSelectEntireExperience="passIsUsingSelectEntireExperience"
                  @passIsUsingSelectEntireEducationOrCertification="passIsUsingSelectEntireEducationOrCertification"
                  @warmUpPythonCloudFunctions="warmUpPythonCloudFunctions"
                />
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </div>
    
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import lodash from 'lodash'
import axios from 'axios'
import pdf from 'vue-pdf'
import { PDFDocument } from 'pdf-lib'
import TokensInBoxes from '@/components/profile/TokensInBoxes.vue'
import ProfileForm from './ProfileForm.vue'
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor,
    ProfileForm,
    TokensInBoxes,
    pdf,
  },
  props: {
    dossier: Object,
    ocrResults: Array,
    originalCvText: String,
    pdfUrl: String,
    dossierHasUnsavedChanges: Boolean,
    isOcrResultsLoaded: Boolean,
    isConsultant: Boolean,
    isFromToken: Boolean
  },
  data: () => ({
    isDragSelectEnabled: false,
    activeFieldPath: null,
    selectedWordIds: [],
    activeFieldValueBeforeDragSelect: null,
    isProcessingSelectedText: false,
    pagesNb: 0,
    sizeOfPage: null,
    words: [],
    lines: [],
    isComponentDestroyed: false,
    editedFieldPath: null,
    isShowingSelectionTool: false,
    selectedText: '',
    editorToolbar: [[]],
    editorOptions: { formats: [] },
    isUsingSelectEntireExperience: false,
    isUsingSelectEntireEducationOrCertification: false,
    tokensInBoxesComponentKeyForRefresh: 0
  }),
  beforeDestroy() {
    this.isComponentDestroyed = true
  },
  async mounted() {
    await this.init()
  },
  computed: {
    ...mapGetters({
      user: "user"
    }),
    isUsingTechnicalSkillsDescription() {
      return this.dossier.profile.skills.isUsingTechnicalSkillsDescription
    },
    tokens() {
      return (this.isUsingSelectEntireExperience || this.isUsingSelectEntireEducationOrCertification || this.isUsingSelectEntireListOfEducationsAndCertifications) ? this.lines : this.words
    },
    isUsingSelectEntireListOfEducationsAndCertifications() {
      return this.editedFieldPath.length > 0 && this.editedFieldPath[0] === 'selectEntireListOfEducationsAndCertifications'
    }
  },
  methods: {
    async init() {
      this.warmUpPythonCloudFunctions()
      const existingPdfBytes = await fetch(this.pdfUrl).then(res => res.arrayBuffer())
      const pdfDoc = await PDFDocument.load(existingPdfBytes, { ignoreEncryption: true })
      const pages = pdfDoc.getPages()
      this.pagesNb = pages.length
      this.sizeOfPages = pages.map(page => page.getSize())

      // Wait for this.isOcrResultsLoaded to be true
      while (this.isOcrResultsLoaded !== true) {
        await new Promise(resolve => setTimeout(resolve, 1000))
      }
      this.setWordsAndLines()
      this.tokensInBoxesComponentKeyForRefresh += 1
    },
    async passSelectedTokens(selectedTokenIds) {
      this.isProcessingSelectedText = true
      let text = '';
      if (selectedTokenIds.length > 0) {
        if (this.isUsingSelectEntireExperience || this.isUsingSelectEntireEducationOrCertification || this.isUsingSelectEntireListOfEducationsAndCertifications) {
          // Tokens are lines
          const columns = await this.getSelectedLinesGroupedByColumns(selectedTokenIds)
          const texts = await Promise.all(
            columns.map(lines => {
              const selectedWordIds = lodash.flatten(lines.map(line => line.words.map(word => word.id)))
              return this.getDescriptionAsQuillFromSelectedWordIds(selectedWordIds)
            })
          )
          text = texts.join('<p><br></p>')
        } else {
          // Tokens are words
          const selectedWordIds = selectedTokenIds
          text = await this.getDescriptionAsQuillFromSelectedWordIds(selectedWordIds)
        }
      }
      this.isProcessingSelectedText = false
      this.selectSelectedTextForCopying(text)
    },
    selectSelectedTextForCopying(text) {
      this.selectedText = text
      setTimeout(() => {
        const node = document.querySelector('#vueEditorForCopying .ql-editor');
        if (document.body.createTextRange) {
          const range = document.body.createTextRange();
          range.moveToElementText(node);
          range.select();
        } else if (window.getSelection) {
          const selection = window.getSelection();
          const range = document.createRange();
          try {
            range.selectNodeContents(node);
            selection.removeAllRanges();
            selection.addRange(range);
          } catch {} // eslint-disable-line
        } else {
          console.warn("Could not select text in node: Unsupported browser.");
        }
      }, 1)
    },
    blurOfVueEditorForCopying() {
      this.$refs.tokensInBoxes.blurOfVueEditorForCopying()
    },
    setIsShowingSelectionTool() {
      if (this.editedFieldPath) {
        const section = this.editedFieldPath[0]
        if (['basics', 'functionalSkills', 'educations', 'certifications', 'experiences', 'selectEntireListOfEducationsAndCertifications'].includes(section)) {
          this.isShowingSelectionTool = true
        } else if (section === 'technicalSkills') {
          this.isShowingSelectionTool = this.isUsingTechnicalSkillsDescription || this.dossier.isUsingParserV2
        } else {
          this.isShowingSelectionTool = false
        }
      } else {
        this.isShowingSelectionTool = false
      }
      this.isDragSelectEnabled = this.isShowingSelectionTool
    },
    updateProfileAndCreateDossier(data) {
      this.$emit('updateProfileAndCreateDossier', data)
    },

    //////////// BELOW ARE HELPERS
    setWordsAndLines() {
      const words = []
      const lines = []
      for (let [pageIndex, page] of this.ocrResults.entries()) {
        for (let line of page.lines) {
          line.position = this.getTokenPosition(line, pageIndex)
          line.id = line.Id
          lines.push(line)
          for (let word of line.words) {
            word.position = this.getTokenPosition(word, pageIndex)
            words.push(word)
          }  
        }
      }
      this.words = words
      this.lines = lines
    },
    getTokenPosition(token, pageIndex) {
      const maxPageWidth = Math.max(...this.sizeOfPages.map(sizeOfPage => sizeOfPage.width))
      
      let pdfHeight = 0
      let pageTop = 0
      for (let [index, sizeOfPage] of this.sizeOfPages.entries()) {
        if (index < pageIndex) {
          pageTop += sizeOfPage.height
        }
        pdfHeight += sizeOfPage.height
      }
      const pageHeight = this.sizeOfPages[pageIndex].height
      const pageWidth = this.sizeOfPages[pageIndex].width
      
      return {
        top: (pageTop + token.Geometry.BoundingBox.Top * pageHeight) / pdfHeight,
        height: token.Geometry.BoundingBox.Height * pageHeight / pdfHeight,
        left: (token.Geometry.BoundingBox.Left * pageWidth + (maxPageWidth - pageWidth)/2) / maxPageWidth,
        width: token.Geometry.BoundingBox.Width * pageWidth / maxPageWidth
      }
    },
    positionCursorHint(event) {
      const documentContainerElement = document.getElementById('pdfContainer')
      const cursorTagHintElement = document.getElementById('cursorTagHint')
      if (!documentContainerElement || !cursorTagHintElement) return;
      const mousePos = {
        x: event.pageX,
        y: event.pageY
      };
      cursorTagHintElement.style.visibility = 'visible'
      cursorTagHintElement.style.left = mousePos.x + 6 + "px"
      cursorTagHintElement.style.top = mousePos.y - documentContainerElement.offsetTop - 80 + "px"
    },
    async getDescriptionAsQuillFromSelectedWordIds(selectedWordIds) {
      let lines = await this.getMergedLinesFromSelectedWordIds(selectedWordIds)

      // If lines are in the same y-axis, make 3 consecutive lines
      lines = this.setAlignedLinestoNewLines(lines)

      // Set indentation to lines
      const leftPositions = lines.map(line => this.getLeftDistanceWithoutBulletChar(line))
      const averageLetterWidth = this.getAverageLetterWidthFromSelectedWordIds(selectedWordIds)
      const lineIndents = await this.getLineIndents(leftPositions, averageLetterWidth)
      const linesWithIndents = this.getLinesWithIndents(lines, lineIndents)

      // Create quill
      const quillStr = this.getQuillStr(linesWithIndents)
      return quillStr
    },
    setAlignedLinestoNewLines(lines) {
      // If lines are in the same y-axis, make 3 consecutive lines
      const newLines = [lines[0]]
      for (let [index, lineB] of lines.entries()) {
        if (index > 0) {
          const lineA = newLines[newLines.length - 1]
          const areLinesOnSameYAxis = lineB.verticalCenter > lineA.firstWord.Geometry.BoundingBox.Top && lineB.verticalCenter < lineA.firstWord.Geometry.BoundingBox.Top + lineA.firstWord.Geometry.BoundingBox.Height
          if (areLinesOnSameYAxis) {
            // Hack the firstWord position to make it the same as lineA
            lineB.firstWord.Geometry.BoundingBox.Left = lineA.firstWord.Geometry.BoundingBox.Left
          }
          newLines.push(lineB)
        }
      }
      return newLines
    },
    getAverageLetterWidthFromSelectedWordIds(selectedWordIds) {
      const words = this.words.filter(word => selectedWordIds.includes(word.id))
      return lodash.mean(words.map(word => word.Geometry.BoundingBox.Width / word.Text.length))
    },
    async getTechnicalEnvFromSelectedWordIds(selectedWordIds) {
      const lines = await this.getMergedLinesFromSelectedWordIds(selectedWordIds)
      return lines.map(line => line.text).join('\n')
     },
    async getMergedLinesFromSelectedWordIds(selectedWordIds) {
      // Among selected lines, get highest distance between page left (0) and the line's right.
      const maxEndDistance = Math.max(...this.lines.filter(line => line.words.find(word => selectedWordIds.includes(word.id))).map(line => line.Geometry.BoundingBox.Left + line.Geometry.BoundingBox.Width))
      // List the line spacings
      const lineSpacingClusters = await this.getLineSpacingClusters(selectedWordIds)

      // Choose to merge lines or not
      const selectedLines = this.lines.filter(line => line.words.find(word => selectedWordIds.includes(word.id)))
      let lines = selectedLines.filter(line => !(line.Text.length === 1 && this.isCharacterABullet(line.Text[0]))) // remove lines that are only a bullet...
      if (lines.length === 0) lines = selectedLines // ... unless there is no lines left.

      const isThereAtLeastOneSelectedBullet = Boolean(lines.find(line => this.isCharacterABullet(line.Text[0])))

      const newLines = []
      for (const [index, line] of lines.entries()) {
        const lineA = newLines[newLines.length - 1]
        const lineBWords = line.words.filter(word => selectedWordIds.includes(word.id))
        const lineB = {
          text: lineBWords.map(word => word.Text).join(' '),
          endDistance: Math.max(...lineBWords.map(word => word.Geometry.BoundingBox.Left + word.Geometry.BoundingBox.Width)),
          firstWord: lineBWords[0],
          verticalCenter: line.Geometry.BoundingBox.Top + line.Geometry.BoundingBox.Height/2,
          averageSpaceWidth: this.getAverageSpaceWidth(line),
          leftDistanceWithoutBulletChar: this.getLeftDistanceWithoutBulletChar(line),
          leftDistance: line.words[0].Geometry.BoundingBox.Left,
          words: lineBWords
        }
        const lineCText = index+1 < lines.length ? lines[index+1].words.filter(word => selectedWordIds.includes(word.id)).map(word => word.Text).join(' ') : ''
        if (index > 0 && this.isMergingLines(lineA, lineB, maxEndDistance, lineSpacingClusters, isThereAtLeastOneSelectedBullet, lineCText)) {
          // merge
          newLines[newLines.length - 1] = {
            text: [lineA.text, lineB.text].join(' '),
            endDistance: lineB.endDistance, // used for lineA
            firstWord: lineB.firstWord, // used for lineB,
            verticalCenter: lineB.verticalCenter, // used for lineA and lineB
            averageSpaceWidth: lineB.averageSpaceWidth, // used for lineA
            leftDistanceWithoutBulletChar: lineA.leftDistanceWithoutBulletChar, // used for lineA and lineB
            leftDistance: line.words[0].Geometry.BoundingBox.Left,
            words: lineA.words.concat(lineB.words) // used for detection of lines indentations
          }
        } else {
          // don't merge
          newLines.push(lineB)
        }
      }
      return newLines
    },
    async getLineIndents(leftPositions, averageLetterWidth) {
      try {
        if (leftPositions.length >= 3) {
          const maxDifferenceBetweenLeftPositions = Math.max(...leftPositions) - Math.min(...leftPositions)
          if (maxDifferenceBetweenLeftPositions > 2 * averageLetterWidth) {
            return await this.callPythonClusterLineIndents(leftPositions)
          }
        }
        return leftPositions.map(x => 0) // eslint-disable-line
      } catch { // eslint-disable-line
        return leftPositions.map(x => 0) // eslint-disable-line
      }
    },
    getLinesWithIndents(lines, lineIndents) {
      let linesWithIndents = []
      for (const [index, line] of lines.entries()) {
        let text = line.text
        if (this.isCharacterABullet(text[0])) text = text.substring(1).trim() // if line starts with a bullet char, remove this char/word
        linesWithIndents.push({
          text,
          indent: lineIndents[index]
        })
      }

      // lineB.indent cannot be higher that lineA.indent + 1
      let newLinesWithIndents = [linesWithIndents[0]]
      for (const [index, lineB] of linesWithIndents.entries()) {
        if (index > 0) {
          const lineA = newLinesWithIndents[newLinesWithIndents.length - 1]
          if (lineB.indent > lineA.indent + 1) {
            lineB.indent = lineA.indent + 1
          }
          newLinesWithIndents.push(lineB)
        }
      }
      linesWithIndents = newLinesWithIndents

      // If there are only paragraphs, convert them to bullets
      if (!linesWithIndents.find(lineWithIndent => lineWithIndent.indent > 0)) {
        linesWithIndents = linesWithIndents.map(lineWithIndent => {
          lineWithIndent.indent = 1
          return lineWithIndent
        })
      }

      return linesWithIndents
    },
    getQuillStr(linesWithIndents) {
      let html = ''
      let isUlOpen = false
      for (let lineWithIndent of linesWithIndents) {
        if (lineWithIndent.indent > 0) {
          // Bullet line
          if (!isUlOpen) html += `<ul>`
          html += `<li class="ql-indent-${lineWithIndent.indent - 1}">${lineWithIndent.text}</li>`
          isUlOpen = true
        } else {
          // Paragraph line
          if (isUlOpen) html += `</ul>`
          isUlOpen = false
          html += `<p>${lineWithIndent.text}</p>`
        }
      }
      if (isUlOpen) html += `</ul>`
      return html
    },
    isMergingLines(lineA, lineB, maxEndDistance, lineSpacingCluters, isThereAtLeastOneSelectedBullet, lineCText) {  // eslint-disable-line
      // If we have enough space to put the first word of line B at the end of lineA, it means there was a real backspace used. So no merging.
      if (lineA.endDistance + lineB.firstWord.Geometry.BoundingBox.Width + lineA.averageSpaceWidth < maxEndDistance) return false

      // If lineB starts with a bulletpoint character, then lineB is a new bullet. So no merging.
      const lineBFirstChar = lineB.firstWord.Text[0]
      if (this.isCharacterABullet(lineBFirstChar)) return false

      // If the lineA has an unclosed parenthesis "(" and lineB has a closed parenthesis ")", merge.
      // Also merge if lineB has no parenthesis but the following line C has a closed parenthesis ")".
      const parenthesisLineA = lineA.text.split('').filter(char => ['(', ')'].includes(char))
      const parenthesisLineB = lineB.text.split('').filter(char => ['(', ')'].includes(char))
      const parenthesisLineC = lineCText.split('').filter(char => ['(', ')'].includes(char))
      if (parenthesisLineA.length > 0) {
        const lineAHasUnclosedParenthesis = parenthesisLineA[parenthesisLineA.length - 1] === '('
        if (lineAHasUnclosedParenthesis) {
          if (parenthesisLineB.length > 0) {
            if (parenthesisLineB[0] === ')') return true
          } else {
            if (parenthesisLineC.length > 0 && parenthesisLineC[0] === ')') return true
          }
        }
      }
      
      // If line spacing between lineA and lineB is higher than the typical LineSpacing of paragraphs, it means it is not a same paragraph/bullet. So, no merging.
      const spacing = lineB.verticalCenter - lineA.verticalCenter
      const clusterIndex = lineSpacingCluters.find(cluster => cluster.spacings.includes(spacing))
      const clusterIndexOfParagraphSpacing = lineSpacingCluters.find(cluster => cluster.isParagraphSpacing)
      const spacingIsHigherThanParagraphSpacing = clusterIndex > clusterIndexOfParagraphSpacing
      if (spacingIsHigherThanParagraphSpacing) return false
      
      // If lineA ends with a "." or "!" or "?", no merging.
      if (lineA.text.endsWith('.') || lineA.text.endsWith('!') || lineA.text.endsWith('?')) return false

      // If lineA (with its potential bullet character removed) and lineB have different left-distance, it means they are not part of the same paragraph/bullet. So, no merging.
      const averageSpaceWidth = lineB.averageSpaceWidth || lineA.averageSpaceWidth
      if (averageSpaceWidth) {
        const linesHaveSameLeftDistance = Math.abs(lineB.leftDistance - lineA.leftDistance) < averageSpaceWidth * 2
        const linesHaveSameLeftDistanceWithoutBulletChar = Math.abs(lineB.leftDistanceWithoutBulletChar - lineA.leftDistanceWithoutBulletChar) < averageSpaceWidth * 2
        if (!linesHaveSameLeftDistance && !linesHaveSameLeftDistanceWithoutBulletChar) return false
      } else {
        // only if both lineB and lineA are single-word lines
        return false
      }

      if (isThereAtLeastOneSelectedBullet) {
        // Look at the content from the original textkernel profile to see if there is a bullet between lineA and lineB
        // This approach is only relevant if there is at least one bullet in the selected lines
        const isMergingFromOriginalCvText = this.getIsMergingFromOriginalCvText(lineA, lineB)
        if (isMergingFromOriginalCvText !== undefined) return isMergingFromOriginalCvText
      }
      
      // If the cv language is not german, and lineB starts with an uppercased letter, no merging.
      if (this.dossier.profile.cvLanguages !== 'DE' && lineB.text[0].toLowerCase() !== lineB.text[0]) return false


      // Merge line if nothing above tells us to not merge.
      return true

      // The following rules are not precise enough.
      // // If lineA is the line that defined the maxEndDistance, let's not merge.
      // if (lineA.endDistance.toFixed(4) === maxEndDistance.toFixed(4)) return false
    },
    isCharacterABullet(char) {
      return !/[a-zA-Z0-9éèêëàáâäûüùúîïíīôöòóœÿÉÈÊËÀÁÂÄÛÜÙÚÎÏÍĪÔÖÒÓŒŸ?%"',\\/;@$€[\]{}!&(]/.test(char)
    },
    getLeftDistanceWithoutBulletChar(line) {
      const firstWord = line.words[0]
      if (this.isCharacterABullet(firstWord.Text[0])) {
        // First char is bullet
        if (firstWord.Text.trim().length === 1) {
          // First word is only a bullet (with potential spaces)
          if (line.words.length > 1) {
            // If there is a second word in line
            return line.words[1].Geometry.BoundingBox.Left
          } else {
            // If there is no other word: only a bullet.
            return firstWord.Geometry.BoundingBox.Left
          }
        } else {
          // First word is not just a bullet
          return firstWord.Geometry.BoundingBox.Left + this.getAverageSpaceWidth(line)
        }
      } else {
        // First char is not bullet
        return firstWord.Geometry.BoundingBox.Left
      }
    },
    getAverageSpaceWidth(line) {
      const spaceWidths = []
      for (const [index, word] of line.words.entries()) {
        if (index > 0) {
          const wordA = line.words[index-1]
          const wordB = word
          const spaceWidth = wordB.Geometry.BoundingBox.Left - (wordA.Geometry.BoundingBox.Left + wordA.Geometry.BoundingBox.Width)
          spaceWidths.push(spaceWidth)
        }
      }
      if (spaceWidths.length === 0) return 0
      else return lodash.mean(spaceWidths)
    },
    getLineSpacingClusters(selectedWordIds) {
      const lines = this.lines.filter(line => line.words.find(word => selectedWordIds.includes(word.id)))
      if (lines.length <= 3) return []
      const allSpacings = []
      for (let [index, line] of lines.entries()) {
        if (index > 0) {
          const lineA = lines[index - 1]
          const lineB = line
          const bbA = lineA.Geometry.BoundingBox
          const bbB = lineB.Geometry.BoundingBox
          const spacing = (bbB.Top + bbB.Height/2) - (bbA.Top + bbA.Height/2) // use middle height of lines
          allSpacings.push(spacing)
        }
      }
      const spacings = [...new Set(allSpacings)].sort()
      return this.callPythonClusterLineSpacings(spacings)
    },
    warmUpPythonCloudFunctions() {
      // In order to prevent a cold start of the python cloud functions at /parse-experiences step,
      // call them right now with useless data so that are fully started-up at next step.
      this.callPythonClusterLineSpacings([0.1, 0.2, 0.3])
      this.callPythonClusterLineIndents([0.1, 0.2, 0.3])
    },
    callPythonClusterLineSpacings(spacings) {
      // const url = `https://europe-west1-${process.env.VUE_APP_projectId}.cloudfunctions.net/python_cluster_line_spacings`
      const url = `https://europe-west1-esnwebservices-prod.cloudfunctions.net/python_cluster_line_spacings`
      return axios({
        method : 'POST',
        url,
        data: {
          spacings
        }
      }).then(res => res.data)
    },
    callPythonClusterLineIndents(leftPositions) {
      // const url = `https://europe-west1-${process.env.VUE_APP_projectId}.cloudfunctions.net/python_cluster_line_indents`
      const url = `https://europe-west1-esnwebservices-prod.cloudfunctions.net/python_cluster_line_indents`
      return axios({
        method : 'POST',
        url,
        data: {
          leftPositions
        }
      }).then(res => res.data)
    },
    passEditedFieldPath(data) {
      this.editedFieldPath = data.editedFieldPath
    },
    passIsUsingSelectEntireExperience(data) {
      this.isUsingSelectEntireExperience = data.isUsingSelectEntireExperience
      this.tokensInBoxesComponentKeyForRefresh += 1
    },
    passIsUsingSelectEntireEducationOrCertification(data) {
      this.isUsingSelectEntireEducationOrCertification = data.isUsingSelectEntireEducationOrCertification
      this.tokensInBoxesComponentKeyForRefresh += 1
    },
    async getSelectedLinesGroupedByColumns(selectedLineIds) {
      // Find Xs where no line exist at this X
      // Go through all Xs being contained between most left point of all lines, and most right point of all lines
      const lines = selectedLineIds.map(lineId => this.lines.find(line => line.id === lineId))
      const minLeft = Math.ceil( Math.min(...lines.map(line => line.Geometry.BoundingBox.Left)) * 100) / 100
      const maxRight = Math.floor( Math.max(...lines.map(line => line.Geometry.BoundingBox.Left + line.Geometry.BoundingBox.Width)) * 100) / 100

      const columns = []
      let linesInThisColumn = []
      for (let x = minLeft * 100; x <= maxRight * 100; x++) {
        const selectedLinesAtThisX = lines.filter(line => {
          return line.Geometry.BoundingBox.Left * 100 <= x && (line.Geometry.BoundingBox.Left + line.Geometry.BoundingBox.Width) * 100 >= x
        })
        if (selectedLinesAtThisX.length > 0) {
          linesInThisColumn = [... new Set(linesInThisColumn.concat(selectedLinesAtThisX))]
        } else {
          if (linesInThisColumn.length > 0) {
            columns.push(linesInThisColumn)
            linesInThisColumn = []
          }
        }
      }
      columns.push(linesInThisColumn)

      return columns
    },

    getIsMergingFromOriginalCvText(lineA, lineB) {
      let isMerging = this.isMergingBasedOnDocumentText(this.originalCvText, lineA.text, lineB.text)
      if (isMerging !== undefined) return isMerging;
      else {
        isMerging = this.isMergingBasedOnDocumentText(this.overSimplifyText(this.originalCvText), this.overSimplifyText(lineA.text), this.overSimplifyText(lineB.text))
        if (isMerging !== undefined) return isMerging;
        // We don't know.
        return undefined
      }
    },
    isMergingBasedOnDocumentText(originalCvText, lineAText, lineBText) {
      const defaultAnswer = undefined
      if (originalCvText.includes(lineAText) && originalCvText.includes(lineBText)) {
        const regexp = new RegExp(`(${lodash.escapeRegExp(lineAText)}).*?(${lodash.escapeRegExp(lineBText)})`, 'gs')
        const isBulletForEachMatch = []
        for (let text of originalCvText.match(regexp)) {
          text = text.slice(lineAText.length, text.length - lineBText.length).trim()
          
          // If between lineA and lineB are only a bunch of spaces and line break, 
          if (!text) {
            isBulletForEachMatch.push(false)
            continue
          }
          // If there is just a bullet between lineA and lineB
          if (text.length === 1 && this.isCharacterABullet(text[0])) {
            isBulletForEachMatch.push(true)
            continue
          }
          // Else, there are other stuff between, so remove the match
        }

        // If no match, we don't know
        if (isBulletForEachMatch.length === 0) return defaultAnswer

        // If multiple matches with some being bullets and some not, we don't know
        if ([... new Set(isBulletForEachMatch)].length >= 2) return defaultAnswer
        
        // If only one match, merge if no bullet, don't merge if bullet
        const isBullet = isBulletForEachMatch[0]
        return !isBullet

      } else {
        return defaultAnswer
      }
    },
    overSimplifyText(text) {
      return text.replace(/\.\.\./g, '').replace(/'/g, '').replace(/\s/g, '').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    },
    showVideoDialog() {
      this.$emit('showVideoDialog')
    }
  },
  watch: {
    editedFieldPath: {
      handler() {
        this.setIsShowingSelectionTool()
      }
    },
    isUsingTechnicalSkillsDescription: {
      handler() {
        this.setIsShowingSelectionTool()
      }
    },

  }
}
</script>

<style scoped>
.pdfPageEmbed {
  width: 100%;
  height: calc(100vh - 48px)
}
.msWordPageEmbed {
  width: 100%;
  height: calc(100vh - 48px)
}

.pdfContainerWithOcrResultsNotLoadedYet {
  cursor: not-allowed !important;
  margin-bottom: 91px
}

.pdfContainerWithSelectionToolEnabled {
  cursor: crosshair !important;
  margin-bottom: 91px
}

#cursorTagHint{
  z-index:1;
  width:50px;
  height:50px;
  border-radius:50%;
  position:absolute;
}

.v-dialog__content {
  width: 50%;
}


</style>


<i18n>
{
  "fr": {
    "1": "Votre outil de sélection rapide sera prêt d'ici une minute.",
    "a": "Sélectionner",
    "b": "Gommer",
    "c": "Sélectionnez dans le CV le texte à copier",
    "c1": "Sélectionnez le nom de l'entreprise",
    "c2": "Sélectionnez la date de début",
    "c3": "Sélectionnez la date de fin",
    "c4": "Sélectionnez le titre de l'expérience",
    "c5": "Sélectionnez la description",
    "c6": "Sélectionnez l'environnement technique",
    "d": "Annuler",
    "e0": "Expérience",
    "e1": "sur",
    "e2": "Retour à l'étape 1",
    "f": "Êtes-vous sûr de vouloir retourner à l'étape de sélection des expériences ?",
    "g": "Vous perdrez les données actuelles de l'étape 2.",
    "h": "Confirmer",
    "i": "Annuler",
    "i2": "Expérience précédente",
    "j": "Expérience suivante",
    "k": "Créer le dossier",
    "l": "Étape 2 :",
    "m": "Remplissez les champs de cette expérience avec notre outil de sélection",
    "n": "Créez des rectangles pour sélectionner des phrases entières.",
    "n2": "Voir un exemple",

    "x1": "Ctrl + C",
    "x2": "pour copier le texte sélectionné",
    "x3": "Gardez la touche Shift enfoncée si vous souhaitez combiner plusieurs sélections de textes.",
    "x4": "Copiez du texte du CV original",
    "x5": "Sélectionnez d'un rectangle les mots du CV que vous souhaitez copier.",
    "video0": "Voir un exemple"
  },
  "en": {
    "1": "Your quick-selection tool will be available within a minute.",
    "a": "Select",
    "b": "Erase",
    "c": "Select in the CV some text to copy",
    "c1": "Select company",
    "c2": "Select start date",
    "c3": "Select end date",
    "c4": "Select title",
    "c5": "Select description",
    "c6": "Select technical environment",
    "d": "Cancel",
    "e0": "Experience",
    "e1": "of",
    "e2": "Back to step 1",
    "f": "Are you sure you want to get back to step 1 ?",
    "g": "You will lose all current data related to step 2.",
    "h": "Confirm",
    "i": "Cancel",
    "i2": "Previous experience",
    "j": "Next experience",
    "k": "Create CV",
    "l": "Step 2:",
    "m": "Fill the fields of this experience with our selection tool",
    "n": "Click-and-drag to select multiple words and sentences.",
    "n2": "See an example",

    "x1": "Ctrl + C",
    "x2": "to copy the selected text",
    "x3": "Keep the Shift key pressed if you wish to combine multiple text selections.",
    "x4": "Copy text from the original CV",
    "x5": "Click-and-drag to select the words of the CV that you want to copy.",

    "video0": "See an example"
  }
}
</i18n>